import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import './newGame.css'
import {getNewGameIndex} from '../../redux/newGame.redux.js'
import { Link} from "react-router-dom"
import GiftAlert from '../../component/gift-alert/gift-alert.js'
import {getElementPosition} from '../../util.js'
import {userList} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'
import {xxflStaus} from '../../redux/newGame.redux.js'
@withRouter
@connect(
  state=>state.newGame,
  {getNewGameIndex,xxflStaus}
)
@connect(
  state=>state.chatuser,
  {userList}
)

class NewGameRecommend extends React.Component{

	constructor(props){
		super(props)
		this.state={
  			getGames:'',
  			visible:false,
  			showSelectWelfare:false,
		    visible:false,
		    showGetSuccess:false,
		    iTop:'',
		    giftData:{},
		    key:1
		   
		  
    		} 		
	}

	componentDidMount(){
  
    	this.props.getNewGameIndex() ///首页
    	
    
  	}
  	showStatus(istatus){
			
		var str = ''
		if(istatus===1){
			str = '已领完'
		}else if(istatus===2){
			str = '已领取'
		}
		return str
  	}
  	
	showGiftAlert(e,item){
		var _this = this
		
		this.setState({
  			showSelectWelfare:true,
  			visible:false,
  			showGetSuccess:false,
  			iTop:'800px',
  			giftData:item,
  			key:this.state.key+1
  			
  		})
  		
	}
	handleDetail(id){
  		this.props.history.push('/game-detail/'+id)
  		this.props.xxflStaus(1)	
  	}
	render(){
		
		const {GameIndexList} = this.props
		var getStatus = ''
		
		return (
			<div className="new-games">
				<div className="comTitle"><h6>游戏推荐</h6><Link to="/new-game">查看更多</Link></div>

		            <ul className="new-game-list">
					
                    {
                    	GameIndexList.data&&GameIndexList.data.map((item,i)=>{
                    		return (
								 <li key={i} >
				                    {
				                    	<div className="game-prop-box" >
				                  			<div className="game-prop-img" style={{backgroundImage:"url("+(item.imgurl)+")"}}></div>
				                  			<span className={
					                  					item.type===1?'game-prop-name active2':
					                  						item.type===2?'game-prop-name active':
					                  							'game-prop-name'
					                  			  }
					                  	    >{item.gamename}</span>
				                       		<em>{item.number}人领取福利</em>
				                      

				                       		<a href="javascript:;" onClick={()=>this.handleDetail(item.game_id)}></a>
				                       
				                       
				                       
				                        
				                    </div>
				                    
				                }
	
				                </li>

                    		)

                    	})
                    }
                     
		            </ul>
				{
				this.state.showSelectWelfare&&<GiftAlert
					key={this.state.key}
					showSelectWelfare={this.state.showSelectWelfare}
					visible={this.state.visible}
					showGetSuccess={this.state.showGetSuccess}
					iTop={this.state.iTop}
					iTitle={"游戏礼包推荐"}
					giftData={{'id':this.state.giftData.packinfo.good_id}||''}
					ifNewGame={this.state.giftData.id||''}
					iStatus={this.state.giftData.status}				
				></GiftAlert>
				}
			</div>

		)
	}

}

export default NewGameRecommend



// WEBPACK FOOTER //
// ./src/component/new-games/newGames.js